import { createContext, useContext, useState } from "react";
import { toast } from "sonner";

const LocationContext = createContext(null);
export const useLocation = () => useContext(LocationContext);

const KEY = "nabor_location";

export function LocationProvider({ children }) {
  const [loc, setLoc] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
  });

  const save = (l) => {
    setLoc(l);
    localStorage.setItem(KEY, JSON.stringify(l));
  };

  const requestMyLocation = () =>
    new Promise((resolve) => {
      if (!navigator.geolocation) { toast.error("Geolocation not supported"); return resolve(null); }
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const l = { lat: pos.coords.latitude, lng: pos.coords.longitude, label: "Near me" };
          save(l); toast.success("Using your current location"); resolve(l);
        },
        () => { toast.error("Could not get your location"); resolve(null); },
        { timeout: 8000 }
      );
    });

  const setPostcode = async (postcode) => {
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&countrycodes=gb&q=${encodeURIComponent(postcode)}`);
      const data = await res.json();
      if (data && data[0]) {
        const l = { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon), label: postcode.toUpperCase() };
        save(l); toast.success(`Showing results near ${l.label}`); return l;
      }
      toast.error("Postcode not found");
    } catch { toast.error("Could not look up postcode"); }
    return null;
  };

  const clear = () => { setLoc(null); localStorage.removeItem(KEY); };

  return (
    <LocationContext.Provider value={{ loc, requestMyLocation, setPostcode, setManual: save, clear }}>
      {children}
    </LocationContext.Provider>
  );
}
